import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
// import Link from "@mui/material/Link";

function BreadRegistarHorasEscritorio() {
  return (
    <Breadcrumbs
      separator="›"
      aria-label="breadcrumb"
      style={{ marginBottom: '10px', marginTop: '12px' }}
    >
      <Link to="/app" color="textPrimary">
        Inicio
      </Link>
      <Link to="/app/registarHoras/escritorio" color="textPrimary">
        Lista de Obras
      </Link>
      <Typography color="textPrimary">Registar Horas</Typography>
    </Breadcrumbs>
  );
}
export default BreadRegistarHorasEscritorio;
